import React, { useContext } from "react";
import {Navigate, useLocation } from "react-router-dom";
import AuthContext from "../context/AuthContext";

const PrivateRoute = ({ children }) => {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  return user ? (
    children
  ) : (
    <Navigate to={`/signin?redirect=${location.pathname}`} replace={true} />
  );
};

export default PrivateRoute;
